import React from "react";
import thanksImage from "../assets/images/donations/thankDonation.svg";
import { Button } from "./ui/button";
export default function DonationComplete({ onDone }) {
  const handleDone = () => {
    onDone?.();
  };
  return (
    <>
      <div className="flex justify-center mt-16 px-4 md:px-16 lg:px-32">
        <div className="max-w-3xl w-full bg-white rounded-2xl shadow-lg p-10 flex flex-col items-center">
          <img
            src={thanksImage}
            alt="Thank you for DOnation"
            width={200}
            height={200}
            className="mb-6"
          />

          <h2 className="text-[32px] font-semibold text-brand-primary text-center mb-4">
            Thank you for your <br /> donation!
          </h2>
          <p className="text-[20px] text-text-primary text-center mb-8">
            Your recipient should receive the <br /> funds shortly.
          </p>

          <div className="flex space-x-4">
            <Button
              onClick={handleDone}
              className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-20 py-2 font-semibold rounded-full w-full"
            >
              Done
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
